import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";

/**
 * Gate for authenticated-only pages. If there is no logged-in user (including
 * after a token expiry or inactivity logout), redirect to sign in and remember
 * where the user was trying to go.
 */
export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return (
      <Navigate
        to="/auth/signin"
        replace
        state={{
          from: location,
          message: "Your session has ended. Please sign in to continue.",
        }}
      />
    );
  }

  return children;
}
